import { Table } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CustomTable } from "../../../../../../../components";
import { moneyFormat } from "../../../../../../../plugins/numberFormat";
import { getCurrency } from "../../../../../../../plugins/utils";
import { useComission } from "../../../../context/ComissionContext";
import { useGetPromotionFee } from "../../../../hooks/comissionreport.hooks";
import styles from "./style.module.scss";

const CURRENCY = getCurrency();

const Promotion = ({}) => {
  const { t } = useTranslation();
  const { selectedMonth, agentBonusId, selectedWeek } = useComission();
  const { data, hasNextPage, isFetchingNextPage, fetchNextPage, isLoading, isError } =
    useGetPromotionFee({
      params: {
        // period_month: selectedMonth.value,
        period_date: selectedWeek?.value?.split("~")[0],
      },
      agent_bonus_id: agentBonusId,
      options: {
        enabled: agentBonusId !== null && selectedWeek !== null,
        getNextPageParam: (lastPage, pages) => {
          if (pages.length < lastPage.last_page) {
            return pages.length + 1;
          } else {
            return undefined;
          }
        },
      },
    });
  const [summary, setSummary] = useState(0);
  const [localData, setLocalData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const columns = [
    {
      title: t("comission.table.promoType"),
      width: 100,
      align: "center",
      dataIndex: "trans_category",
      render: (text, record, index) => <>{t(`comission.promo.category.${text}`)}</>,
    },
    {
      title: `${t("normal.amount")} (${t(`global.currency.${CURRENCY}`)})`,
      width: 100,
      align: "center",
      dataIndex: "sum_total_amount",
      render: (text, record, index) => (
        <div className={`${styles.amount} ${text <= 0 ? styles.redColor : styles.greenColor}`}>
          {moneyFormat(text)}
        </div>
      ),
    },
  ];

  const loadMore = () => {
    if (isFetchingNextPage === false && localData.length > 0) {
      fetchNextPage();
    }
  };

  useEffect(() => {
    if (data) {
      const page_length = data.pages.length;
      if (page_length <= 1) {
        setLocalData([...data.pages[0].data]);
      } else {
        setLocalData((prevState) => {
          return [...prevState, ...data.pages[page_length - 1].data];
        });
      }
      const totalFee = data.pages[page_length - 1].data.reduce(
        (sum, a) => sum + (a.sum_total_amount || 0),
        0,
      );
      setSummary(totalFee);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      {isError ? (
        ""
      ) : (
        <CustomTable
          columns={columns}
          dataSource={localData}
          hasMore={hasNextPage}
          loadMore={loadMore}
          showInifineScroll={true}
          summary={() => {
            return (
              <Table.Summary fixed="top">
                <Table.Summary.Row>
                  <Table.Summary.Cell index={0}>
                    <div className={styles.summaryCell}>{t("normal.summary")}</div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1}>
                    <div
                      className={`${styles.summaryCell} ${styles.content} ${
                        summary <= 0 ? styles.redColor : styles.greenColor
                      }`}
                    >
                      {moneyFormat(summary || 0)}
                    </div>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={2} />
                </Table.Summary.Row>
              </Table.Summary>
            );
          }}
        />
      )}
    </div>
  );
};

export default Promotion;
